/**
 * GALLI-NOIR CART DRAWER LOGIC - CLEAN VERSION
 */

async function updateCartDrawer() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Update Counts
        document.querySelectorAll('#CartCount, #HeaderCartCount').forEach(el => {
            el.textContent = cart.item_count;
        });

        // Update Subtotal
        const subtotalEl = document.getElementById('CartSubtotal');
        if (subtotalEl) {
            subtotalEl.textContent = formatMoney(cart.total_price);
        }

        // Update Items Container
        const container = document.getElementById('CartItemsContainer');
        if (container) {
            if (cart.item_count === 0) {
                container.innerHTML = `
                    <div class="empty-cart-msg" style="text-align: center; padding: 50px 20px;">
                        <p style="font-family: var(--font-mono); font-size: 14px; color: var(--text-grey);">YOUR CART IS EMPTY</p>
                        <a href="/collections/all" class="checkout-btn" style="display: inline-block; margin-top: 20px; text-decoration: none;">START SHOPPING</a>
                    </div>`;
            } else {
                let html = '';
                cart.items.forEach(item => {
                    const variantTitle = item.variant_title ? item.variant_title.toUpperCase() : '';
                    html += `
                        <div class="cart-item" data-id="${item.key}">
                            <img src="${item.image}" class="item-img" alt="${item.title}">
                            <div class="item-details">
                                <div class="item-title">${item.product_title.toUpperCase()}</div>
                                <div class="item-variant">${variantTitle}</div>
                                <div class="qty-controls">
                                    <div class="qty-btn" onclick="updateCartQty('${item.key}', ${item.quantity - 1})">-</div>
                                    <div class="qty-val">${item.quantity}</div>
                                    <div class="qty-btn" onclick="updateCartQty('${item.key}', ${item.quantity + 1})">+</div>
                                </div>
                                <div class="item-price">${formatMoney(item.final_line_price)}</div>
                            </div>
                        </div>`;
                });
                container.innerHTML = html;
            }
        }

        // Update Free Shipping Bar
        updateShippingBar(cart.total_price);

    } catch (error) {
        console.error('Error updating cart drawer:', error);
    }
}

function updateShippingBar(totalPrice) {
    const threshold = 750000; // PKR 7,500 in cents
    const messageEl = document.getElementById('ShippingMessage');
    const fillEl = document.getElementById('ShippingProgressFill');

    if (!messageEl || !fillEl) return;

    if (totalPrice >= threshold) {
        messageEl.textContent = "YOU HAVE UNLOCKED FREE SHIPPING!";
        fillEl.style.width = '100%';
    } else {
        const left = threshold - totalPrice;
        const formattedLeft = formatMoney(left).replace('PKR ', '');
        messageEl.textContent = "PKR " + formattedLeft + " AWAY FROM FREE SHIPPING";
        fillEl.style.width = ((totalPrice / threshold) * 100) + '%';
    }
}

async function updateCartQty(key, quantity) {
    if (quantity < 0) quantity = 0;
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
        });
        await response.json();
        updateCartDrawer();
    } catch (error) {
        console.error('Error updating quantity:', error);
    }
}

async function addUpsell(variantId) {
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        await response.json();
        updateCartDrawer();
    } catch (error) {
        console.error('Error adding upsell:', error);
    }
}

function formatMoney(cents) {
    // Basic PKR formatter
    const amount = (cents / 100).toFixed(2);
    return 'PKR ' + parseFloat(amount).toLocaleString();
}

// Global intercept for form submits
document.addEventListener('submit', async (e) => {
    if (e.target.action && e.target.action.includes('/cart/add')) {
        e.preventDefault();
        const formData = new FormData(e.target);

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });
            const item = await response.json();

            if (response.ok) {
                // Open drawer - assuming toggleCartDrawer is globally available from liquid
                if (typeof toggleCartDrawer === 'function') {
                    toggleCartDrawer();
                } else {
                    const drawer = document.getElementById('GalliCartDrawer');
                    if (drawer) {
                        drawer.style.display = 'flex';
                        updateCartDrawer();
                    }
                }
            } else {
                alert(item.description || 'Error adding to cart');
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
        }
    }
});
